module.exports = __webpack_public_path__ + "img/Macau.a726b361.png";